import styled, { css } from 'styled-components';

export const GradientContainer = styled.div`
    position: relative;
    text-align: center;
    height: 320px;
    background: linear-gradient(180deg, rgba(248, 248, 248, 0.7) 5.85%, rgba(206, 235, 233, 0.7) 25.05%, rgba(200, 245, 242, 0.7) 43.12%, rgba(224, 247, 245, 0.7) 70.58%, rgba(248, 248, 248, 0.7) 100%);
    padding: 0 15px;
`;

export const GradientDownArrowContainer = styled.div`
    position: relative;
`;

export const MembershipGradientTextContainer = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing.xl};
`;

export const IntroducingMembershipTitleContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing.m};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const LoginLink = styled.span`
    color: ${({ theme }) => theme.colors.verdigris};
    text-decoration: underline;
`;

export const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align:left;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const BenefitContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const SuccessCheckIconContainer = styled.div``;

export const FormContainer = styled.div`
    text-align: left;
    margin-top: ${({ theme }) => theme.spacing.l};
    margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const InputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const InputNotesContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const SuccessfulRegistrationContainer = styled.div(
    ({ theme }) => css`
    margin: ${theme.spacing.xm} ${theme.spacing.m};
    text-align: center;
`);

export const SuccessfulRegistrationTextContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing.m};
    margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const MembershipInfoContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin: 0 15px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${({ theme }) => theme.colors.seasalt};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const SpacerSection = styled.div`
    margin-top: 158px;
`;
